module.exports = require('./helpers/bundle-url').getBundleURL('79Wa6') + "logo-dark.bdeff35f.svg";